// extracted by mini-css-extract-plugin
module.exports = {"centered":"Login_centered__1A5dv","centeredText":"Login_centeredText__35pXy"};